import {
  RejectWorkRefusalRequestResponse,
  UpdateWorkRefusalRequestParams,
} from 'api/laborerPortalAPI/workRefusalRequests'
import { CallAPIAction, Status } from 'api/types'
import { GeneralFailResponse } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  errorMessage: string
  requestId: UpdateWorkRefusalRequestParams['requestId'] | null
} & Status

const initialState: State = {
  errorMessage: '',
  requestId: null,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_ASYNC,
    Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_SUCCESS,
    Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_FAIL,
    RejectWorkRefusalRequestResponse,
    GeneralFailResponse,
    {},
    { params: UpdateWorkRefusalRequestParams }
  >,
): State => {
  switch (action.type) {
    case Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_ASYNC:
      return {
        ...state,
        ...action.status,
        errorMessage: '',
        requestId: action.callAPIActionPayload.params.requestId,
      }
    case Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_SUCCESS:
      return {
        ...state,
        ...action.status,
      }
    case Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_FAIL:
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    default:
      return state
  }
}
